import {useParams} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import UserCardProfessionalCaregiverOfficeScreen from '../../../user-cards/edit/user-card.professional-caregiver.screen';
import {useOffice} from '../../../../../../../contexts/office/context';
import {useAuth} from '../../../../../../../contexts/auth/context';
import {RolePermissionType} from '../../../../../../../backend/enums/role-permission-type';
import {ScreenPaths} from '../../../../../../../enums';
import {translations} from '../../../../../../../i18n/translations';

export default function SeniorUserCardProfessionalCaregiverOfficeScreen() {
  const {entityId}: {entityId: string} = useParams();
  const {t} = useTranslation();
  const officeContext = useOffice();
  const {hasWritePermission} = useAuth();

  const senior = officeContext.state.userForm?.user;
  const seniorId = senior?.id || '';
  const seniorName = senior?.displayName || senior?.name || '';

  return (
    <UserCardProfessionalCaregiverOfficeScreen
      canWrite={hasWritePermission(RolePermissionType.Seniors_DigitalInclusion_Cards)}
      titleCrumbs={[
        {
          label: t(translations.screen_paths.professional_caregiver_seniors),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}`,
        },
        {
          label: seniorName,
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${seniorId}${ScreenPaths.Senior_PersonalData}${ScreenPaths.Senior_Profile}`,
        },
        {
          label: t(translations.role_permissions_section['digital-inclusion']),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${seniorId}${ScreenPaths.Senior_DigitalInclusion}`,
        },
        {
          label: t(translations.screen_paths.senior_user_cards),
          link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${seniorId}${ScreenPaths.Senior_DigitalInclusion}${ScreenPaths.Senior_UserCards}`,
        },
      ]}
    />
  );
}
